import '@beehive/components/dist/purple.css';
import App from 'containers/App';
import { getUserInfo } from 'modules/actions/account';
import configureStore from 'modules/store';
import * as qs from 'querystring';
import React, { ReactElement, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import addIntlLocalData from './addIntlLocalData';
import { showAlert } from 'utils';
import request from '@mpc/common/src/utils/nxios';
import { dainit, daLogin, isDevOrTest } from '@mpc/common/src/utils/datracker';

// 引入bedrock全局样式
import '@bedrock/components/lib/styles/base.less';
import './index.less';
import './styles/bedrock/theme.less';
import './styles/index.less';
import { waterMark } from 'utils';
import _ from 'lodash';
import { setSType, versionMonitorByHash, scout, isProdHostName } from '@mpc/common/src/utils';
import PxToRemWrapper from '@mpc/common/src/features/PxToRemWrapper';
import { Theme } from '@bedrock/components';
import { solarCooperationInvoke, solarNonAuthInvoke } from '@mpc/common/src/services/api';
import { initializePartnershipRequestInvoker } from '@mpc/common/src/features/SupplierNew/Initialization';
import { PartnershipRequestInvoker } from '@purchase/supplier';
import { getSolarToken, setVendorStorage } from '@mpc/common/src/utils/vendorStorage';

// React Grab - 开发环境调试工具
const ReactGrabLoader: React.FC = () => {
  useEffect(() => {
    if (!isProdHostName()) {
      // 动态加载 react-grab（使用 data-options 配置快捷键）
      const script = document.createElement('script');
      script.src = '//unpkg.com/react-grab/dist/index.global.js';
      script.crossOrigin = 'anonymous';
      script.async = true;
      // 通过 data-options 配置快捷键为 Control+Shift+Z
      if (process.env.NODE_ENV === 'development') {
        script.setAttribute(
          'data-options',
          JSON.stringify({
            collapsed: false,
            enabled: true,
            freezeReactUpdates: true,
            activationKey: 'Ctrl+Shift+Z',
          }),
        );
      } else {
        script.setAttribute(
          'data-options',
          JSON.stringify({
            collapsed: true,
            enabled: true,
            activationKey: 'Ctrl+Shift+Z',
          }),
        );
      }
      document.head.appendChild(script);

      return () => {
        document.head.removeChild(script);
      };
    }
  }, []);

  return null;
};

const store = configureStore();
const querystring = location.search ? location.search.slice(1) : '';
const querystringInfo = qs.parse(querystring);
addIntlLocalData();

setSType('outer');

// 监听版本更新
versionMonitorByHash();

export const render = async (oldRender: () => void) => {
  if (isDevOrTest() && querystringInfo.mail) {
    await request(`/api/outsource/auth/develop/login?mail=${querystringInfo.mail}`, {});
  }
  initializePartnershipRequestInvoker(solarCooperationInvoke, solarNonAuthInvoke);
  let token = getSolarToken();
  if (token) {
    const { data } = (await PartnershipRequestInvoker.getInstance().partnerShipOpenApiIdentityParseToken({
      token: token,
    })) as any;
    setVendorStorage(data?.vendorId as string, data?.tenant?.tenantCode);
  }
  if (isDevOrTest() && querystringInfo.vendorId && querystringInfo.tenantCode) {
    setVendorStorage(querystringInfo.vendorId as string, querystringInfo.tenantCode as string);
  }
  await store
    .dispatch(getUserInfo())
    .then((result: any) => {
      const init = async () => {
        const userMail = _.get(result, ['data', 'email']);

        scout({ appId: isDevOrTest() ? 'cb290332' : '8bf166ba', userName: `${userMail}` });
        dainit();
        daLogin(userMail);

        if (result?.res_code !== -1 && result?.data) {
          waterMark(result?.data);
        }
      };
      return init();
    })
    .catch((error: any) => {
      console.error(error);
      showAlert({ type: 'error', message: '用户未登录！' });
    });

  oldRender();
};

export function rootContainer(container: ReactElement) {
  return (
    <PxToRemWrapper>
      <ReactGrabLoader />
      <Provider store={store}>
        <HashRouter>
          <Theme>
            <App />
          </Theme>
        </HashRouter>
      </Provider>
    </PxToRemWrapper>
  );
}
